import _default from './Segment';
export { _default as default };